import { validateEnum, values } from '@weft/utils';
import { useMemo } from 'react';
import { type PlanCreationStep } from '../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { useStepCounter } from './use-step-counter';

export type UseVyStepper<Step extends number> = {
  currentStep: Step;
  nextStep: () => void;
  previousStep: () => void;
  onFinalStep?: () => void;
  isFinalStep: boolean;
  goToStep: (step: Step) => void;
};

export function useVyStepper<Step extends number>(defaultStep: Step, steps: Record<string, number>, onFinalStep?: () => void): UseVyStepper<Step> {
  const { currentStep, incrementSteps, decrementSteps, goToStep: goToExactStep } = useStepCounter(values(steps).length, defaultStep);

  const parsedCurrentStep = useMemo(() => {
    validateEnum(currentStep, steps);

    return currentStep as Step;
  }, [currentStep]);

  const goToStep = (step: PlanCreationStep) => {
    goToExactStep(step);
  };

  const isFinalStep = parsedCurrentStep + 1 === Math.max(...values(steps));

  return {
    currentStep: parsedCurrentStep,
    nextStep: incrementSteps,
    previousStep: decrementSteps,
    onFinalStep,
    isFinalStep,
    goToStep,
  };
}